import styled from 'styled-components';
import theme from '@/data/theme';

const EditorWrapper = styled.div`
  border: 1px solid #edeef1;
  border-radius: 5px;
  padding: 0.625rem;
  width: 100%;
  min-height: 100px;
  background: white;
  font-size: 12px;
  font-family: ${theme.fonts.primary};

  font-weight: 400;

  strong {
    font-weight: 600;
  }

  .ProseMirror {
    outline: none;
    min-height: 100px;

    p {
      margin: 0;
      padding: 0;
      line-height: 1.5;
    }
    > * + * {
      margin-top: 0.5em;
    }

    &.ProseMirror-focused {
      outline: none;
    }
  }
`;

export { EditorWrapper };
